import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { useButtonAvailability } from '../hooks/use-button-availability';
import { ZoomControllerButtonType as ButtonType } from '../types/button-type';
import { ZoomControllerButton as Button } from './button';
const b = bemClassBuilder('v-zoom-controller-buttons');
export const ZoomControllerButtons = props => {
    const { handler, showPanButtons, showZoomButtons, zoomButtonsPosition, isDisabled } = props;
    const availability = useButtonAvailability(handler);
    if (!showPanButtons && !showZoomButtons) {
        return null;
    }
    const baseProps = {
        availability,
        onClick: handler.handleButtonClick,
        isDisabled
    };
    return (_jsxs("div", { className: b.block(), children: [showZoomButtons && (_jsxs("div", { className: b.element('zoom-buttons', { position: zoomButtonsPosition }), children: [_jsx(Button, Object.assign({ type: ButtonType.ZoomIn }, baseProps)), _jsx(Button, Object.assign({ type: ButtonType.ZoomOut }, baseProps)), _jsx(Button, Object.assign({ type: ButtonType.ResetZoom }, baseProps))] })), showPanButtons && (_jsxs("div", { className: b.element('pan-buttons'), children: [_jsx(Button, Object.assign({ type: ButtonType.PanLeft }, baseProps)), _jsx(Button, Object.assign({ type: ButtonType.PanRight }, baseProps)), _jsx(Button, Object.assign({ type: ButtonType.PanUp }, baseProps)), _jsx(Button, Object.assign({ type: ButtonType.PanDown }, baseProps))] }))] }));
};
ZoomControllerButtons.displayName = 'ZoomControllerButtons';
//# sourceMappingURL=buttons.js.map